export default __webpack_public_path__ + "static/media/ketovacation@2x.beae6ecb.jpg";